<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">LEDGER ACCOUNTS List</h3>
          <button
                type="button"
                class="btn btn-success"
                data-toggle="modal"
                data-target="#modal-xl"
              >
                <i class="fa fa-plus"></i>
              </button>
          
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
         
        <div class="card">
            <div class="card-header d-flex p-0">
              <h3 class="card-title p-3">LEDGER GROUPS LIST</h3>
              <ul class="nav nav-pills ml-auto p-2">
                <li class="nav-item">
                  <a class="nav-link active" href="#tab_1" data-toggle="tab"
                    >ALL</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#tab_2" data-toggle="tab">ASSETS</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#tab_3" data-toggle="tab"
                    >LIABILITIES</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#tab_4" data-toggle="tab">EQUITY</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#tab_5" data-toggle="tab"
                    >EXPENSES</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#tab_6" data-toggle="tab"
                    >REVENUE</a
                  >
                </li>
              </ul>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="tab-content">
                <div class="tab-pane active" id="tab_1">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'id'">
                        <a :href="props.row.id" class="btn btn-info btn-sm"
                          ><i class="fa fa-eye"></i
                        ></a>
                        <a :href="props.row.id" class="btn btn-success btn-sm"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_2">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'id'">
                        <a :href="props.row.id" class="btn btn-info btn-sm"
                          ><i class="fa fa-eye"></i
                        ></a>
                        <a :href="props.row.id" class="btn btn-success btn-sm"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_3">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'id'">
                        <a :href="props.row.id" class="btn btn-info btn-sm"
                          ><i class="fa fa-eye"></i
                        ></a>
                        <a :href="props.row.id" class="btn btn-success btn-sm"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.tab-pane -->
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_4">
                  <p>testing data</p>
                </div>
                <!-- /.tab-pane -->
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_5">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'id'">
                        <a :href="props.row.id" class="btn btn-info btn-sm"
                          ><i class="fa fa-eye"></i
                        ></a>
                        <a :href="props.row.id" class="btn btn-success btn-sm"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.tab-pane -->
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_6">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'id'">
                        <a :href="props.row.id" class="btn btn-info btn-sm"
                          ><i class="fa fa-eye"></i
                        ></a>
                        <a :href="props.row.id" class="btn btn-success btn-sm"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.tab-pane -->
              </div>
              <!-- /.tab-content -->
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->        
          
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all LEDGER ACCOUNTS
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>



      <div class="modal fade" id="modal-xl">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">ADD LEDGER ACCOUNT</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="col-md-12">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <form role="form">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >Ledger Type <span class="red">*</span></label
                            >
                            <select class="form-control" required>
                              <option>ASSET</option>
                              <option>LIABILITY</option>
                              <option>EQUITY</option>
                              <option>EXPENSE</option>
                              <option>REVENUE</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label
                              >Display Name <span class="red">*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Group Display Name"
                              required
                            />
                          </div>
                          <div class="form-group">
                            <label>Code <span class="red">*</span></label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Code"
                            />
                          </div>
                          <div class="form-group">
                            <label
                              >Show In Day Book
                              <span class="red">*</span></label
                            >
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="radio1"
                              />
                              <label class="form-check-label">Yes</label>
                            </div>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="radio1"
                                checked=""
                              />
                              <label class="form-check-label">No</label>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Ledger Group <span class="red">*</span></label
                            >
                            <select class="form-control" required>
                              <option></option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label
                              >System Name <span class="red">*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="System Name"
                              required
                            />
                          </div>

                          <div class="form-group">
                            <label
                              >Is Bank Account <span class="red">*</span></label
                            >
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="radio1"
                              />
                              <label class="form-check-label">Yes</label>
                            </div>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="radio1"
                                checked=""
                              />
                              <label class="form-check-label">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!--/.col (right) -->
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-success">
                SAVE ACCOUNTS
              </button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CANCEL
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      

</div>
</template>

<script>
export default {
  name: 'LedgerAccounts',
  data () {
    return {
      columns: [
        {
          label: 'NAME',
          field: 'name'
        },
        {
          label: 'SYSTEM NAME',
          field: 'systemName'
        },
        {
          label: 'GROUP',
          field: 'group'
        },
        {
          label: 'TYPE',
          field: 'type'
        },

        {
          label: 'SYSTEM A/C',
          field: 'systemAccount'
        },

        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: [
        {
          id: 1,
          name: "SHAREHOLDER'S FUND",
          systemName: 'SHAREHOLDER FUND',
          group: '',
          type: 'Equity',
          systemAccount: 'yes',
          balance: '500'
        },
        {
          id: 2,
          name: 'CASH & CASH EQUIVALENT',
          systemName: 'CASH AND CASH EQUIVALENT',
          group: '',
          type: 'Asset',
          systemAccount: 'yes',
          balance: '15777'
        },
        {
          id: 3,
          name: 'CURRENT LIABILITY',
          systemName: 'CURRENT LIABILITY',
          group: '',
          type: 'Liability',
          systemAccount: 'yes',
          balance: '345'
        },
        {
          id: 4,
          name: 'REVENUE FROM OPERATIONS',
          systemName: 'REVENUE FROM OPERATIONS',
          group: '',
          type: 'Revenue',
          systemAccount: 'yes',
          balance: '12456775'
        },
        {
          id: 5,
          name: 'EMPLOYEE BENEFIT EXPENSE',
          systemName: 'EMPLOYEE BENEFIT EXPENSE',
          group: '',
          type: 'Expense',
          systemAccount: 'yes',
          balance: '103455'
        },
        {
          id: 6,
          name: 'OTHER INCOME',
          systemName: 'OTHER INCOME',
          group: '',
          type: 'Revenue',
          systemAccount: 'no',
          balance: '0'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// LedgerAccounts.vue?122ffb4e